'use strict';

var debounce = require('lodash/debounce');
var desktopSearch = require('./desktopSearch');
var mobileSearch = require('./mobileSearch');
var searchFieldUi = require('./searchFieldUi');
var syncResetButton = searchFieldUi.syncResetButton;
var endpoint = $('.suggestions-wrapper').data('url');
var DESKTOP_MIN_CHARS = 1;
var UP_KEY = 38;
var DOWN_KEY = 40;
var DIRECTION_DOWN = 1;
var DIRECTION_UP = -1;

/**
 * Retrieves Suggestions element relative to scope
 *
 * @param {Object} scope - Search input field DOM element
 * @return {JQuery} - .suggestions-wrapper element
 */
function getSuggestionsWrapper(scope) {
	return $(scope).siblings('.suggestions-wrapper');
}

/**
 * Minimum characters before AJAX suggestions
 *
 * @param {Object} scope - Search input field DOM element
 * @return {number}
 */
function getMinChars(scope) {
	if (mobileSearch.isMobileSearchField($(scope))) {
		return mobileSearch.getCompactMinChars();
	}

	return DESKTOP_MIN_CHARS;
}

/**
 * Tear down Suggestions panel
 */
function tearDownSuggestions() {
	$('input.search-field').val('');
	$('.suggestions-wrapper').empty();
	$('input.search-field').each(function () {
		syncResetButton($(this));
	});

	if (mobileSearch.isOpen()) {
		mobileSearch.close();
	}
}

/**
 * Process Ajax response for SearchServices-GetSuggestions
 *
 * @param {Object|string} response - Empty object literal if null response or string with rendered
 *                                   suggestions template contents
 */
function processResponse(response) {
	var $suggestionsWrapper = getSuggestionsWrapper(this).empty();
	var $field = $(this);

	desktopSearch.stopSuggestionsSpinner($field);

	if (typeof (response) !== 'object') {
		$suggestionsWrapper.append(response).show();
		syncResetButton($field);

		desktopSearch.handleSuggestionsResponse($field);
		mobileSearch.handleSuggestionsResponse($field);

		// Trigger screen reader by setting aria-describedby with the new suggestion message.
		var suggestionsList = $('.suggestions .item');
		if ($(suggestionsList).length) {
			$('input.search-field').attr('aria-describedby', 'search-result-count');
		} else {
			$('input.search-field').removeAttr('aria-describedby');
		}
	} else {
		$suggestionsWrapper.hide();
	}
}

/**
 * Retrieve suggestions
 *
 * @param {Object} scope - Search field DOM element
 */
function getSuggestions(scope) {
	var minChars = getMinChars(scope);

	if ($(scope).val().length >= minChars) {
		desktopSearch.startSuggestionsSpinner($(scope));
		$.ajax({
			context: scope,
			url: endpoint + encodeURIComponent($(scope).val()),
			method: 'GET',
			success: processResponse,
			error: function () {
				desktopSearch.stopSuggestionsSpinner($(this));
			}
		});
	} else {
		syncResetButton($(scope));
		getSuggestionsWrapper(scope).empty();

		if (mobileSearch.isMobileSearchField($(scope))) {
			mobileSearch.clearDynamicResults($(scope));
		}
	}
}

/**
 * Handle Search Suggestion Keyboard Arrow Keys
 *
 * @param {Integer} direction takes positive or negative number constant, DIRECTION_UP (-1) or DIRECTION_DOWN (+1)
 */
function handleArrow(direction) {
	// get all li elements in the suggestions list
	var suggestionsList = $('.suggestions .item');
	if (suggestionsList.filter('.selected').length === 0) {
		suggestionsList.first().addClass('selected');
		$('input.search-field').each(function () {
			$(this).attr('aria-activedescendant', suggestionsList.first()[0].id);
		});
	} else {
		suggestionsList.each(function (index) {
			var idx = index + direction;
			if ($(this).hasClass('selected')) {
				$(this).removeClass('selected');
				$(this).removeAttr('aria-selected');
				if (suggestionsList.eq(idx).length !== 0) {
					suggestionsList.eq(idx).addClass('selected');
					suggestionsList.eq(idx).attr('aria-selected', true);
					$(this).removeProp('aria-selected');
					$('input.search-field').each(function () {
						$(this).attr('aria-activedescendant', suggestionsList.eq(idx)[0].id);
					});
				} else {
					suggestionsList.first().addClass('selected');
					suggestionsList.first().attr('aria-selected', true);
					$('input.search-field').each(function () {
						$(this).attr('aria-activedescendant', suggestionsList.first()[0].id);
					});
				}
				return false;
			}
			return true;
		});
	}
}

module.exports = function () {
	$('form[name="simpleSearch"]').submit(function (e) {
		var suggestionsList = $('.suggestions .item');
		if (suggestionsList.filter('.selected').length !== 0) {
			e.preventDefault();
			suggestionsList.filter('.selected').find('a')[0].click();
		}
	});

	$('input.search-field').each(function () {
		syncResetButton($(this));

		/**
		 * Use debounce to avoid making an Ajax call on every single key press by waiting a few
		 * hundred milliseconds before making the request. Without debounce, the user sees the
		 * browser blink with every key press.
		 */
		var debounceSuggestions = debounce(getSuggestions, 300);
		var $field = $(this);

		$field.on('input', function () {
			syncResetButton($field);
		});

		$field.on('keyup focus', function (e) {
			// Capture Down/Up Arrow Key Events
			switch (e.which) {
				case DOWN_KEY:
					handleArrow(DIRECTION_DOWN);
					e.preventDefault(); // prevent moving the cursor
					break;
				case UP_KEY:
					handleArrow(DIRECTION_UP);
					e.preventDefault(); // prevent moving the cursor
					break;
				default:
					debounceSuggestions(this, e);
			}
		});
	});

	$('.site-search .reset-button').on('click', function (e) {
		e.preventDefault();

		var $field = $(this).siblings('.search-field');
		$field.val('').trigger('input');
		syncResetButton($field);
		getSuggestionsWrapper($field[0]).empty();

		if (mobileSearch.isMobileSearchField($field)) {
			mobileSearch.clearDynamicResults($field);
		}
	});
};

module.exports.tearDownSuggestions = tearDownSuggestions;
